import { render } from "./JobManagementAdmin.vue?vue&type=template&id=4fb02ea0&scoped=true"
import script from "./JobManagementAdmin.vue?vue&type=script&lang=js"
export * from "./JobManagementAdmin.vue?vue&type=script&lang=js"

import "./JobManagementAdmin.vue?vue&type=style&index=0&id=4fb02ea0&scoped=true&lang=css"

import exportComponent from "C:\\SeaFarer\\SeaFarer\\AMDTransportation_FE\\amd_transportation_dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fb02ea0"]])

export default __exports__